export type ReactionData = {
  reaction: string;
  count: number;
  currentUserReacted: boolean;
  // Usernames
  otherUsersWhoReacted: string[];
  reactionShortName: string;
};

export const LIKE = '👍';
